




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import {getStoredProcedure} from '@/data/repos/storedProcedure'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as complianceLinks from "@/data/sources/complianceLinks"

@Component({
  components: {
    DataGrid,
  },
})

export default class ComplianceOutstandingActionsDrillDown extends Vue {
  @Prop() public args!: { locationId: number }
  public fields = [
    {name: 'ElementDescription', title: 'Element', dataType: 'Text', sort: 1, component: DataGridLink, callback: complianceLinks.element},
    {name: 'BuildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.building},
    {name: 'code', title: 'Code', dataType: 'Text', sort: 1},
    {name: 'Reason', title: 'Reason', dataType: 'Text', sort: 1},
    {name: 'Expirydate', title: 'Expiry Date', dataType: 'Text', sort: 1},
    {name: 'ResponsiblePerson', title: 'Responsible Person', dataType: 'Text', sort: 1},
    {name: 'riskLabel', title: 'Risk', dataType: DataType.Text, sort: 1},
    {name: 'risk', title: 'Risk Value', dataType: DataType.Number, sort: 1},
  ]

  public getData(offset = 0, limit = 250) {
    const locationId = this.args.locationId
    const userId = 1 // todo remove
    return getStoredProcedure("AnalyticsCenter", "widget_ComplianceOutstandingActionsDrillDown",
            [locationId, userId],
            this.filter,
            offset, limit)
  }

  private filter(data:any[]):any[] {
    return data.map(item => {
      return {
        ...item,
        BuildingId: item.BuildingID,
      }
    })
  }

}
